import axios from "axios";

import {
  PRODUCT_CREATE_FAIL,
  PRODUCT_CREATE_REQUEST,
  PRODUCT_CREATE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_SETS_LIST_FAIL,
  PRODUCT_SETS_LIST_REQUEST,
  PRODUCT_SETS_LIST_SUCCESS,
  PRODUCT_REVIEW_CREATE_FAIL,
  PRODUCT_REVIEW_CREATE_REQUEST,
  PRODUCT_REVIEW_CREATE_SUCCESS,
  PRODUCT_SEARCH_LIST_FAIL,
  PRODUCT_SEARCH_LIST_REQUEST,
  PRODUCT_SEARCH_LIST_SUCCESS,
  PRODUCT_UPDATE_FAIL,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_VISIBILITY_FAIL,
  PRODUCT_VISIBILITY_REQUEST,
  PRODUCT_VISIBILITY_SUCCESS,
  RELATED_PRODUCT_LIST_FAIL,
  RELATED_PRODUCT_LIST_REQUEST,
  RELATED_PRODUCT_LIST_SUCCESS,
  YMAL_PRODUCT_LIST_FAIL,
  YMAL_PRODUCT_LIST_REQUEST,
  YMAL_PRODUCT_LIST_SUCCESS,
} from "../constants/productConstants";
import { serverIp } from "../config/conf";

export const listProducts =
  (
    categoriesQuery,
    subCategoriesQuery,
    collectionsQuery,
    isLatestArrival,
    gender,
    plating,
    minPrice,
    maxPrice,
    sortBy,
    order,
    selectedStyles,
    isAdmin
  ) =>
    async (dispatch) => {
      try {
        dispatch({ type: PRODUCT_LIST_REQUEST });

        const { data } = await axios.get(
          `${serverIp}/api/products?categories=${categoriesQuery}&subcategories=${subCategoriesQuery}&productCollections=${collectionsQuery}&isLatestArrival=${isLatestArrival}&gender=${gender}&color=${plating}&minPrice=${minPrice}&maxPrice=${maxPrice}&sortBy=${sortBy}&order=${order}&styles=${selectedStyles}&isAdmin=${isAdmin ?? false}`
        );

        dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data });
      } catch (err) {
        dispatch({
          type: PRODUCT_LIST_FAIL,
          payload:
            err.response && err.response.data.message
              ? err.response.data.message
              : err.message,
        });
      }
    };

export const listSetProducts =
  (
    categoriesQuery,
    subCategoriesQuery,
    collectionsQuery,
    isLatestArrival,
    gender,
    plating,
    minPrice,
    maxPrice,
    sortBy,
    order,
    selectedStyles
  ) =>
    async (dispatch) => {
      try {
        dispatch({ type: PRODUCT_SETS_LIST_REQUEST });

        const { data } = await axios.get(
          `${serverIp}/api/products?categories=${categoriesQuery}&subcategories=${subCategoriesQuery}&productCollections=${collectionsQuery}&isLatestArrival=${isLatestArrival}&gender=${gender}&color=${plating}&minPrice=${minPrice}&maxPrice=${maxPrice}&sortBy=${sortBy}&order=${order}&styles=${selectedStyles}`
        );

        dispatch({ type: PRODUCT_SETS_LIST_SUCCESS, payload: data });
      } catch (err) {
        dispatch({
          type: PRODUCT_SETS_LIST_FAIL,
          payload:
            err.response && err.response.data.message
              ? err.response.data.message
              : err.message,
        });
      }
    };

export const relatedListProducts = (id) => async (dispatch) => {
  try {
    dispatch({ type: RELATED_PRODUCT_LIST_REQUEST });

    const { data } = await axios.get(`${serverIp}/api/products/${id}/related`);

    dispatch({ type: RELATED_PRODUCT_LIST_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: RELATED_PRODUCT_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const ymalListProducts = (id) => async (dispatch) => {
  try {
    dispatch({ type: YMAL_PRODUCT_LIST_REQUEST });

    const { data } = await axios.get(`${serverIp}/api/products/${id}/ymal`);

    dispatch({ type: YMAL_PRODUCT_LIST_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: YMAL_PRODUCT_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const listSearchProducts = (query) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_SEARCH_LIST_REQUEST });

    const { data } = await axios.get(`${serverIp}/api/search?query=${query}`);

    dispatch({ type: PRODUCT_SEARCH_LIST_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: PRODUCT_SEARCH_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const listProductDetails = (id, isEdit, isAdmin) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const params = new URLSearchParams();

    if (isEdit !== undefined) {
      params.append('isEdit', isEdit);
    }

    if (isAdmin !== undefined) {
      params.append('isAdmin', isAdmin);
    }

    const queryString = params.toString();


    const { data } = await axios.get(`${serverIp}/api/products/${id}${queryString ? `?${queryString}` : ''}`);

    dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const deleteProduct = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${serverIp}/api/products/${id}`, config);

    dispatch({ type: PRODUCT_DELETE_SUCCESS });
  } catch (err) {
    dispatch({
      type: PRODUCT_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const createProduct = (product) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${serverIp}/api/products`,
      product,
      config
    );

    dispatch({ type: PRODUCT_CREATE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: PRODUCT_CREATE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const copyProduct = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${serverIp}/api/products/${id}`,
      {},
      config
    );

    dispatch({ type: PRODUCT_CREATE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: PRODUCT_CREATE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const updateProduct = (product) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${serverIp}/api/products/${product._id}`,
      product,
      config
    );

    dispatch({ type: PRODUCT_UPDATE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: PRODUCT_UPDATE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const createProductReview =
  (productId, review) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_REVIEW_CREATE_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${serverIp}/api/products/${productId}/reviews`,
        review,
        config
      );

      dispatch({ type: PRODUCT_REVIEW_CREATE_SUCCESS, payload: data });
    } catch (err) {
      dispatch({
        type: PRODUCT_REVIEW_CREATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };


export const visibilityProduct = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_VISIBILITY_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${serverIp}/api/products/visibility/${id}`,
      config
    );

    dispatch({ type: PRODUCT_VISIBILITY_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: PRODUCT_VISIBILITY_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
